import { http } from '@/api/http';

export const exportsApi = {
  /** POST /persons/{guid}/export/fhir — synthesize a FHIR Bundle (local stub). */
  exportFhir: (
    guid: string,
    options?: { signal?: AbortSignal },
  ): Promise<Record<string, unknown>> =>
    http.get<Record<string, unknown>>(
      `/persons/${encodeURIComponent(guid)}/export/fhir`,
      options,
    ),

  /** POST /persons/{guid}/export/phenopacket — synthesize a Phenopacket (local stub). */
  exportPhenopacket: (
    guid: string,
    options?: { signal?: AbortSignal },
  ): Promise<Record<string, unknown>> =>
    http.get<Record<string, unknown>>(
      `/persons/${encodeURIComponent(guid)}/export/phenopacket`,
      options,
    ),
};
